import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

import '../sass/grayscale.scss';

class Layout extends Component {
  render() {
    const { children } = this.props;
    return (
      <StaticQuery
        query={graphql`
          query SiteTitleQuery {
            site {
              siteMetadata {
                title
              }
            }
          }
        `}
        render={data => (
          <>
            <Helmet
              title={data.site.siteMetadata.title}
              meta={[
                {
                  name: 'description',
                  content: 'The Smartest Mortgage Broker Platform Ever Built',
                },
                { name: 'keywords', content: 'site, web, mortgage broker' },
                {
                  name: 'twitter:card',
                  content:
                    'Effi - The Smartest Mortgage Broker Platform Ever Built',
                },
              ]}
            >
              <html lang="en" />
              {/* <link rel="canonical" href="https://effi.com.au/"></link> */}
              <meta property="og:type" content="website" />
              <meta property="og:url" content="https://effi.com.au/" />
              <meta property="og:title" content="Effi" />
              <meta
                property="og:description"
                content="The Smartest Mortgage Broker Platform Ever Built"
              />
              <meta
                property="og:image"
                content="https://effi.com.au/ogimage.jpg"
              />
              <meta
                property="twitter:image"
                content="https://effi.com.au/ogimage.jpg"
              />
              <script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=1c7eec29-759c-42d1-9232-89cc505c76d5"> </script>
            </Helmet>
            <div className={'page-top'}>{children}</div>
          </>
        )}
      />
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
